import React from 'react';
import styled from 'styled-components';
import FormBox from './FormBox';
import VideoDepositLog from '../models/VideoDepositLog';
import getMonthName from '../utils/getMonthName';
import formatISODate from '../utils/formatISODate';

interface Props {
  data: VideoDepositLog[];
}

const AuditSafeLoadReport: React.FC<Props> = props => {
  const { data, ...rest } = props;

  return (
    <FormBox {...rest}>
      <h1>Safe/ATM Load Log</h1>
      <table>
        <thead>
          <tr>
            <th colSpan={9}>
              <UnderlinedText>Safe</UnderlinedText>
            </th>
            <th colSpan={4}>
              <UnderlinedText>ATM</UnderlinedText>
            </th>
          </tr>
          <tr>
            <th>Date by Month</th>
            <th colSpan={3}>Date</th>
            <th>1's Loaded</th>
            <th>5's Loaded</th>
            <th>20's Loaded</th>
            <th>100's Loaded</th>
            <th>Total Loaded Into Safe</th>
            <th>
              Actual Remaining
              <br />
              (Count in Cassette)
            </th>
            <th>
              Actual Rejected
              <br />
              (Count in Rejected)
            </th>
            <th>Dispensed</th>
            <th>Addition Count</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, i) => {
            const prevRow = data[i - 1];
            const showMonth =
              !prevRow ||
              !prevRow.date ||
              (value.date &&
                new Date(prevRow.date).getMonth() !==
                  new Date(value.date).getMonth());

            return (
              <tr key={value.id}>
                {value.date && showMonth ? (
                  <td>
                    {getMonthName(value.date)}{' '}
                    {new Date(value.date.replace('Z', '')).getFullYear()}
                  </td>
                ) : (
                  <td />
                )}
                <td colSpan={3}>
                  <BoxText>{value.date && formatISODate(value.date)}</BoxText>
                </td>
                <td>
                  <BoxText>{value.load100S}</BoxText>
                </td>
                <td>
                  <BoxText>{value.load5S}</BoxText>
                </td>
                <td>
                  <BoxText>{value.load20S}</BoxText>
                </td>
                <td>
                  <BoxText>{value.newLoad100S}</BoxText>
                </td>
                <td>
                  <BoxText>{value.totalLoadedIntoSafeCalc}</BoxText>
                </td>
                <td>
                  <BoxText>{value.atmResidualCount}</BoxText>
                </td>
                <td>
                  <BoxText>{value.atmRejectedCount}</BoxText>
                </td>
                <td>
                  <BoxText>{value.atmReportNum20SDispensed}</BoxText>
                </td>
                <td>
                  <BoxText>{value.atmAdditionCount}</BoxText>
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot />
      </table>
    </FormBox>
  );
};

export default styled(AuditSafeLoadReport)`
  width: 1200px;
  background-color: white;

  h1 {
    border-top: 3px solid black;
    border-bottom: 3px solid black;
    padding: 10px 0 10px;
  }

  thead {
    text-align: left;
    > :last-child {
      text-align: center;
    }
  }

  thead tr:first-child {
    font-size: 24px;
  }

  thead tr:last-child th {
    border-bottom: 3px solid black;
  }

  tbody {
    text-align: center;
  }

  tr > *:nth-child(7) {
    border-right: 1px solid black;
  }

  max-height: 600px;
  overflow: auto;

  @media print {
    display: block;
    width: auto;
    height: auto;
    overflow: visible;
  }
`;

const UnderlinedText = styled('span')`
  border-bottom: 3px solid black;
`;

const BoxText = styled('div')`
  width: 100%;
  height: 100%;
  border: 1px solid black;
`;
